globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.TasksProjects = appCustomerSpace.Modals.TasksProjects || {};

appCustomerSpace.Modals.TasksProjects.SuggestedTasks = (function(superClass) {

  utils.extend(SuggestedTasks, superClass);

  function SuggestedTasks() {
    return SuggestedTasks.__super__.constructor.apply(this, arguments);
  }

  $.extend(SuggestedTasks.prototype, {
    init: function() {
      var modal = this;
      modal._searchTasks();

      modal.tasksProjectFormModal = modal.subModal();
      modal.tasksProjectFormModal.$html.find('.btn-add-suggested-tasks').removeClass('loading');

      modal.$html.find('.task-check').attr('data-original-title', '');

      modal.$html.find('.task').each(function(){
        var $task = $(this);
        if(modal.tasksProjectFormModal._includeTask($task)) $task.remove();
      });

      if(!modal.$html.find('.task').length) {
        modal.$html.find('.no-suggested-task').removeClass('hidden');
      }

      appCustomerSpace.Loader().stop({ $container: modal.$html.find('.modal-body') });

      modal.$html.on('click', '.task', function(){
        $(this).toggleClass('active');
        modal.$html.find('button.submit').prop('disabled', !modal._selectedTasks().length);
      });

      modal.$html.on('click', 'button.submit', function(){
        modal._addTasks();
        modal.close();
      })

      return SuggestedTasks.__super__.init.apply(this, arguments);
    },
    _selectedTasks: function(){
      return this.$html.find('.task.active');
    },
    _addTasks: function(){
      var modal = this;

      $tasks = modal._selectedTasks().removeClass('active hidden').each(function(){
        return modal.tasksProjectFormModal._newTask($(this));
      });

      modal.tasksProjectFormModal._appendTasks($tasks, function($addedTasks) {
        modal.tasksProjectFormModal._activeTask($addedTasks.last());
      });
    },
    _searchTasks: function(){
      var modal = this;

      var searchInput = modal.$html.find(".tasks-search-container input"),
          $tasks       = modal.$html.find(".task");

      searchInput.on("keyup", function() {
        var search = this.value.toLowerCase();

        $tasks.each(function() {
          var $task = $(this);

          if ($task.find(".task-title").text().toLowerCase().search(search) != -1) {
            $task.removeClass("hidden");
          } else {
            $task.addClass("hidden");
          }
        })
      })
    },
    open: function(options, callback) {
      var modal = this;

      appCustomerSpace.Loader().start({ $container: modal.$html.find('.modal-body') });

      return SuggestedTasks.__super__.open.apply(this, arguments);
    }
  });

  return SuggestedTasks;

})(appCustomerSpace.Modal);
